import React from 'react';
import propTypes from 'prop-types';
import { isFunction, noop } from '@dateam/ark';
import { concatClassName, useDebounce } from '@dateam/ark-react';
import { Form } from 'shared-ui';

export type ObservationTypeFilters = {
    label: string;
};

type Props = {
    className?: string;
    onChange?: (filters: ObservationTypeFilters) => void;
};

const FilterBar: React.FC<Props> = ({
    className,
    onChange
}) => {
    const notifyChange = React.useRef(onChange ?? noop);
    const saveChanges = useDebounce((filter: ObservationTypeFilters) => {
        notifyChange.current?.(filter);
    }, 300);

    React.useEffect(() => {
        if (isFunction(onChange)) notifyChange.current = onChange;
    }, [onChange, notifyChange]);

    const [filter, setFilter] = React.useState<ObservationTypeFilters>({ label: '' });

    const handleObservationTypeLabelChange = React.useCallback((newValue: string) => {
        const newFilter: ObservationTypeFilters = {
            ...filter,
            label: newValue
        };

        setFilter(newFilter);
        saveChanges(newFilter);
    }, [saveChanges, filter]);

    return (
        <div className={concatClassName('row', className)}>
            <Form.Group controlId="filter-label" className="col">
                <Form.Label>Nom</Form.Label>
                <Form.Input
                    value={filter.label}
                    autocomplete="off"
                    onChange={handleObservationTypeLabelChange}
                />
            </Form.Group>
        </div>
    );
};

FilterBar.propTypes = {
    className: propTypes.string,
    onChange: propTypes.func
};

FilterBar.defaultProps = {
    className: undefined,
    onChange: undefined
};

export default FilterBar;
